import * as R from "ramda";
import Checkbox from "../../../Checkbox/Checkbox.jsx";
import { toggleItemInArray, facetShape } from "../../ReportBuilderTypes.js";

import { string, arrayOf, func, array } from "prop-types";

const propTypes = {
  title: string.isRequired,
  facets: arrayOf(facetShape).isRequired,
  activeFacets: array.isRequired,
  onFacetChange: func.isRequired,
};

const FacetGroup = (props) => {
  const { title, facets, activeFacets, onFacetChange } = props;

  return (
    <div className="facet-group">
      <h4 className="facet-group__title">{title}</h4>
      <div className="facet-group__facets-container">
        {facets.map((facet, index) => (
          <div key={index} className="facet">
            <Checkbox
              className="checkbox facet__checkbox"
              checked={R.includes(facet.facetGuid, activeFacets)}
              onChange={() => onFacetChange(facet.facetGuid)}
              type="checkbox"
            >
              <div className="facet__title">{facet.facetTitle}</div>
            </Checkbox>
          </div>
        ))}
      </div>
    </div>
  );
};

FacetGroup.propTypes = propTypes;
export default FacetGroup;
